import { environment as testEnvironment } from './environment.test';

export const environment = {
  ...testEnvironment,
  api: {
    url: 'https://api-cidadaodigital-feature.test.betha.cloud/api',
  },
};
